import {
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	AfterContentChecked
} from '@angular/core';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from 'src/app/core/services/auth.service';
import { CurrentUserCompanyInfo } from '../../classes/current-user-company-info';
import { BaseForm } from '../../classes/base-form';
import { mixOf } from '../../classes/mixin-builder';
import { ResponsiveState } from '../../classes/responsive-state';
import { BreakpointService } from '../../services';
import { LucideAngularModule } from 'lucide-angular';
import { SharedModule } from '../../shared.module';

@Component({
	selector: 'app-toolbar',
	standalone: true,
	imports: [LucideAngularModule, SharedModule],
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent
	extends mixOf(BaseForm).with(CurrentUserCompanyInfo, ResponsiveState)
	implements OnInit, AfterContentChecked
{
	@Input() visible = true;

	constructor(
		private readonly sidenavService: SidenavService,
		private readonly responsive: BreakpointObserver,
		private readonly msalService: MsalService,
		private readonly authService: AuthService,
		private readonly cdref: ChangeDetectorRef,
		public readonly breakpointService: BreakpointService
	) {
		super(breakpointService);
	}
	ngOnInit(): void {
		this.setResponsiveState();
		this.handleXSmall();
		this.handleSmall();
		this.handleMedium();
		this.handleLarge();
		this.getUserInfo();
		this.getUserCompany();
		this.getSystemOperator();
	}

	panelOpenState = true;
	currentUserInfo: any;
	breakpointSidenavState = false;
	userSidenavState = false;
	drawerSize = { xSmall: true, small: false, medium: false, large: false };
	userCompany: any;
	userCompanies: { [key: string]: any } = {};
	idCompanySelect: number;
	companySelect: string;

	open(): void {
		this.sidenavService.show();
	}
	getUserInfo() {
		this.currentUserInfo = this.authService.getUserName();
	}

	getUserCompany() {
		this.authService.userCompanies.subscribe(userCompanies => {
			for (const datosEmpresa of userCompanies) {
				const nombreEmpresa = datosEmpresa.razonSocial;
				const claveUnica = `${nombreEmpresa}`;
				this.userCompanies[claveUnica] = datosEmpresa.id;
			}
		});
		this.authService.userCompany.subscribe(companyInfo => {
			this.userCompany = companyInfo.razonSocial || '';
		});
	}

	seleccionarEmpresa(empresaId: number) {
		if (empresaId) {
			this.authService.changeCompany(empresaId);
		}
	}

	handleXSmall(): void {
		this.responsive.observe(Breakpoints.XSmall).subscribe(breakpoint => {
			if (breakpoint.matches) {
				this.breakpointSidenavState = false;
				this.drawerSize.xSmall = true;
				this.drawerSize.small = false;
				this.drawerSize.medium = false;
				this.drawerSize.large = false;
			}
		});
	}

	handleSmall(): void {
		this.responsive.observe(Breakpoints.Small).subscribe(breakpoint => {
			if (breakpoint.matches) {
				this.breakpointSidenavState = false;
				this.drawerSize.xSmall = false;
				this.drawerSize.small = true;
				this.drawerSize.medium = false;
				this.drawerSize.large = false;
			}
		});
	}

	logoff() {
		sessionStorage.clear();
		this.msalService.logout();
	}

	ngAfterContentChecked() {
		this.cdref.detectChanges();
	}

	handleMedium(): void {
		this.responsive.observe(Breakpoints.Medium).subscribe(breakpoint => {
			if (breakpoint.matches) {
				this.breakpointSidenavState = true;
				this.drawerSize.xSmall = false;
				this.drawerSize.small = false;
				this.drawerSize.medium = true;
				this.drawerSize.large = false;
				this.close();
			}
		});
	}

	handleLarge(): void {
		this.responsive.observe(Breakpoints.WebLandscape).subscribe(breakpoint => {
			if (breakpoint.matches) {
				this.breakpointSidenavState = true;
				this.drawerSize.xSmall = false;
				this.drawerSize.small = false;
				this.drawerSize.medium = false;
				this.drawerSize.large = true;
				this.close();
			}
		});
	}

	close(): void {
		this.sidenavService.hide();
	}
}
